module.exports = __webpack_public_path__ + "ff94-guild-btn-cn.png";